// ccb APP 的 "个人信息收集清单"模块
import defaultLayout from '../../layouts/default'

export default {
  path: 'user-info-statement-ccb',
  component: defaultLayout,
  children: [
    {
      name: 'list',
      path: 'list',
      meta: {
        title: '收集个人信息清单'
      },
      component: () => import('./list')
    },
    {
      name: 'baseInfo',
      path: 'base-info',
      meta: {
        title: '收集个人信息清单'
      },
      component: () => import('./base-info')
    },
    {
      name: 'auth',
      path: 'auth-info',
      meta: {
        title: '收集个人信息清单'
      },
      component: () => import('./auth-info')
    },
    {
      name: 'edu',
      path: 'edu-info',
      meta: {
        title: '收集个人信息清单'
      },
      component: () => import('./edu-info')
    },
    {
      name: 'service',
      path: 'service-info',
      meta: {
        title: '收集个人信息清单'
      },
      component: () => import('./service-info')
    },
    {
      name: 'contactDetail',
      path: 'contact-detail',
      meta: {
        title: '通讯录权限'
      },
      component: () => import('./contact-detail')
    },
    {
      name: 'device',
      path: 'device-info',
      meta: {
        title: '收集个人信息清单'
      },
      component: () => import('./device-info')
    },
    {
      name: 'deviceDetail',
      path: 'device-detail',
      meta: {
        title: '收集个人信息清单'
      },
      component: () => import('./device-detail')
    }
  ]
}
